import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-acfe222e")

_pushScopeId("data-v-acfe222e")
const _hoisted_1 = { class: "absence-application" }
const _hoisted_2 = { class: "allowance-detail" }
const _hoisted_3 = { class: "font-bold text-2xl mb-8" }
const _hoisted_4 = { class: "mb-8" }
const _hoisted_5 = { class: "font-bold text-lg mb-1" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)
const _hoisted_7 = { class: "text-xl" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BackPreviousPage = _resolveComponent("BackPreviousPage")
  const _component_ReasonCreateApplication = _resolveComponent("ReasonCreateApplication")
  const _component_ApplicationApproveFlowDetail = _resolveComponent("ApplicationApproveFlowDetail")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_BackPreviousPage, { onClick: _ctx.returnScreen }, null, 8, ["onClick"]),
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, _toDisplayString(_ctx.t('personalSettingApply.absenceApplication')), 1),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, _toDisplayString(_ctx.t('stampRegister.targetDate')), 1),
          _hoisted_6,
          _createVNode("div", _hoisted_7, _toDisplayString(_ctx.targetDate), 1)
        ]),
        _createVNode(_component_ReasonCreateApplication, {
          "is-valid": !_ctx.isDisableSubmit,
          modelValue: _ctx.apiPostData.application_reason,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.apiPostData.application_reason = $event)),
          validated: _ctx.validated,
          errors: _ctx.errors.application_reason,
          "onUpdate:errors": _cache[2] || (_cache[2] = ($event: any) => (_ctx.errors.application_reason = $event)),
          "error-server": _ctx.errorsServer.application_reason,
          onHandleCreateApplication: _ctx.createAbsenceApplication,
          onHandleCancel: _ctx.goToBack
        }, null, 8, ["is-valid", "modelValue", "validated", "errors", "error-server", "onHandleCreateApplication", "onHandleCancel"])
      ])
    ]),
    _createVNode(_component_ApplicationApproveFlowDetail, {
      status: _ctx.statusApplicationFlow,
      createdAt: _ctx.createdAt
    }, null, 8, ["status", "createdAt"])
  ], 64))
})